import {Table as UxTable} from '@deere/ux.uxframe-react'
import { useTranslation } from "react-i18next"
import {getAnswerLabel, getTranslation} from '../../utils/utils'

export default function TablePercentageReview({questions,answers}){
    const colNames = questions[0] && questions[0].dependentQuestions? questions[0].dependentQuestions.map(q => getTranslation(q,'text')):[];
    const { t } = useTranslation();

    function createRow(question,index){
        return <tr key={index}>
                    <td className='p-1'>{getTranslation(question,'text')}</td>
                    {
                        question.dependentQuestions.map(dq =>
                            <td key={dq.id}>
                                {dq.type === 'PERC_STAT'?<h6>{getAnswerLabel(dq,answers)}</h6>:<></>}
                                {dq.type === 'OPEN'?<h6>{getAnswerLabel(dq,answers)}</h6>:<></>}
                            </td>
                        )
                    }   
                </tr>
    }

    return (
        <>
        <UxTable striped hover size="sm" key="1">
        <caption>{t('cp_percentage_tbl_lb')}<small style={{color: 'gray'}}>{t('cp_formula_lb')}</small></caption>
        <thead>
            <tr>
                <th className ='p-1' scope='col'></th>
                {
                    colNames.map(qt => 
                        <th scope="col" className="p-1 text-center" key={qt}>{qt}</th>
                    )
                }
            </tr>
        </thead>
        <tbody>
            {
                questions.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((data,index)=>createRow(data,index))
            }
        </tbody>
    </UxTable>
    </>
    )
}

